import { createAction, props } from '@ngrx/store';

export const areaAssetsFilterOpen = createAction('[Assets] Filters opened');
export const areaAssetsFilterClose = createAction('[Assets] Filters closed');
export const areaAssetsFilterToggle = createAction('[Assets] Filters toggled');
export const searchAssetsBuildings = createAction(
	'[Assets] search assets buildings',
	props<{ buildingsId: string[]; tenants: string[]; search: string }>()
);
export const searchAssetsBuildingsSuccess = createAction(
	'[Assets] assets buildings success',
	props<{ buildings: any }>()
);
export const searchAssetsBuildingsFailure = createAction(
	'[Assets] assets buildings failure',
	props<{ error: any }>()
);
